const SpaceSetupSkeleton = () => <section className="mx-auto max-w-[1158px] py-6 md:px-4 md:py-24" data-sentry-component="SpaceSetupSkeleton" data-sentry-source-file="SpaceSetupSkeleton.jsx">
    <div className="mx-auto mb-5 h-8 w-1/4 animate-pulse rounded-md bg-gray-300"></div>
    <div className="mx-auto mb-5 h-4 w-3/4 animate-pulse rounded-md bg-gray-300"></div>
    <div className="flex gap-4 overflow-hidden">
      {[...Array(3)].map((_, index) => <div key={index} className="flex-1 px-2">
          <div className="h-36 w-full animate-pulse rounded-md bg-gray-300 md:h-80"></div>
          <div className="mt-2 h-4 w-3/4 animate-pulse rounded-md bg-gray-300"></div>
          <div className="mt-1 h-4 w-1/2 animate-pulse rounded-md bg-gray-300"></div>
        </div>)}
    </div>
  </section>;
export default SpaceSetupSkeleton;